<template>
  <section id="about" class="company-info-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">关于我们</h2>
        <div class="title-underline"></div>
      </div>
      
      <div class="content-grid">
        <div 
          class="image-container"
          v-motion
          :initial="{ opacity: 0, x: -50 }"
          :visible="{ opacity: 1, x: 0 }"
          :transition="{ duration: 1.5 }"
        >
          <div class="image-wrapper">
            <img 
              src="https://space.coze.cn/api/coze_space/gen_image?image_size=landscape_16_9&prompt=Modern%20medical%20facility%2C%20clean%20bright%20interior%2C%20professional%20environment%2C%20advanced%20equipment&sign=a336e93a6e73d58b3a4dd2f2f778de59" 
              alt="现代化医疗设施" 
              class="hero-image"
            />
          </div>
          
          <div class="achievement-card">
            <div class="achievement-content">
              <div class="achievement-icon-container">
                <i class="achievement-icon"></i>
              </div>
              <div class="achievement-text">
                <h3 class="achievement-number">15+</h3>
                <p class="achievement-description">年医疗服务经验</p>
              </div>
            </div>
          </div>
        </div>
        
        <div
          class="text-content"
          v-motion
          :initial="{ opacity: 0, x: 50 }"
          :visible="{ opacity: 1, x: 0 }"
          :transition="{ duration: 1.5 }"
        >
          <h3 class="content-title">安徽经纶瑞恒医药科技有限公司</h3>
          
          <p class="content-description">
            安徽经纶瑞恒医药科技有限公司成立于2021年，是一家致力于提供高品质医疗服务和推动医学创新的现代化医疗企业。我们汇聚了国内外顶尖医疗专家，引进国际先进医疗设备，致力于为患者提供全方位、个性化的医疗解决方案。
          </p>
          
          <div class="features-grid">
            <div class="feature-item">
              <div class="feature-icon-container">
                <img src="@/assets/svg/hospital.svg" alt="医院" class="custom-svg-icon">
              </div>
              <div class="feature-text">
                <h4 class="feature-title">专业医疗团队</h4>
                <p class="feature-description">200+名资深医疗专家，多学科协作诊疗</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon-container">
                <img src="@/assets/svg/research_center.svg" alt="研究中心" class="custom-svg-icon">
              </div>
              <div class="feature-text">
                <h4 class="feature-title">先进研究中心</h4>
                <p class="feature-description">国际领先的医学研究实验室和临床试验中心</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon-container">
                <img src="@/assets/svg/newCenter.svg" alt="新中心" class="custom-svg-icon">
              </div>
              <div class="feature-text">
                <h4 class="feature-title">现代化设施</h4>
                <p class="feature-description">5家分院，总面积超过50,000平方米</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon-container">
                <img src="@/assets/svg/quality.svg" alt="质量认证" class="custom-svg-icon">
              </div>
              <div class="feature-text">
                <h4 class="feature-title">卓越医疗品质</h4>
                <p class="feature-description">ISO9001认证，多项国家级医疗质量奖项</p>
              </div>
            </div>
          </div>
          
          <a 
            href="#recruitment" 
            class="recruitment-link"
          >
            了解患者招募计划
            <i class="arrow-icon"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// 无需额外的逻辑，所有功能都在模板中实现
</script>

<style scoped>
.company-info-section {
  padding: 3rem 0; /* 减小移动设备的上下内边距 */
  background-color: white;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 640px) {
  .container {
    padding: 0 1.5rem;
  }
  
  .company-info-section {
    padding: 5rem 0; /* 桌面设备恢复较大内边距 */
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 0 2rem;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 2rem; /* 移动设备减小间距 */
}

@media (min-width: 768px) {
  .section-header {
    margin-bottom: 4rem; /* 桌面设备增大间距 */
  }
}

.section-title {
  font-size: 1.5rem; /* 移动设备字体稍小 */
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .section-title {
    font-size: 2.25rem; /* 桌面设备字体更大 */
  }
}

.title-underline {
  width: 5rem;
  height: 0.25rem;
  background-color: #2563eb;
  margin: 0 auto;
  border-radius: 9999px;
}

.content-grid {
  display: grid;
  grid-template-columns: 1fr; /* 默认单列布局 */
  gap: 2rem; /* 移动设备减小间距 */
  align-items: center;
  margin-left: 0; /* 移动设备取消左偏移 */
}

@media (min-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr 1fr; /* 桌面设备双列布局 */
    margin-left: -60px; /* 桌面设备恢复左偏移 */
  }
}

.image-container {
  position: relative;
  width: 100%; /* 确保图片容器占满宽度 */
  max-width: 800px; /* 限制最大宽度 */
  margin: 0 auto; /* 居中显示 */
}

.image-wrapper {
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  width: 100%; /* 图片容器宽度100% */
}

.hero-image {
  width: 100%; /* 图片宽度100%适应容器 */
  height: auto; /* 高度自动保持比例 */
  max-height: 500px; /* 限制最大高度 */
  object-fit: cover;
}

.achievement-card {
  position: absolute;
  bottom: -1.5rem;
  right: -1.5rem;
  background-color: white;
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 15rem;
  
  /* 移动设备调整成就卡片位置 */
  @media (max-width: 639px) {
    bottom: -1rem;
    right: 1rem;
    padding: 1rem;
    max-width: 12rem;
  }
}

.achievement-content {
  display: flex;
  align-items: center;
  space-x: 1rem;
}

.achievement-icon-container {
  background-color: #dbeafe;
  padding: 0.75rem;
  border-radius: 50%;
}

.achievement-icon::before {
  content: "\f559";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  color: #2563eb;
  font-size: 1.5rem;
}

.achievement-text {
  flex: 1;
}

.achievement-number {
  font-weight: 700;
  font-size: 1.25rem;
  color: #111827;
  margin-bottom: 0.25rem;
}

.achievement-description {
  color: #4b5563;
  font-size: 0.875rem; /* 移动设备稍小字体 */
}

.text-content {
  padding: 0 1rem; /* 增加移动设备内边距 */
}

.content-title {
  font-size: 1.375rem; /* 移动设备稍小字体 */
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .content-title {
    font-size: 1.5rem; /* 桌面设备稍大字体 */
  }
}

.content-description {
  color: #374151;
  margin-bottom: 1.5rem;
  font-size: 1rem; /* 移动设备稍小字体 */
  line-height: 1.6; /* 优化行高提高可读性 */
}

@media (min-width: 768px) {
  .content-description {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.features-grid {
  display: grid;
  grid-template-columns: 1fr; /* 移动设备单列 */
  gap: 1.25rem; /* 移动设备减小间距 */
  margin-bottom: 1.5rem; /* 移动设备减小底部间距 */
}

@media (min-width: 640px) {
  .features-grid {
    grid-template-columns: 1fr 1fr; /* 平板双列 */
    gap: 1.5rem;
    margin-bottom: 2rem;
  }
}

.feature-item {
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 0; /* 增加内边距提高点击区域 */
}

.feature-icon-container {
  background-color: #dbeafe;
  padding: 0.5rem;
  border-radius: 0.5rem;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; /* 防止图标容器被压缩 */
}

.custom-svg-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.feature-text {
  flex: 1;
}

.feature-title {
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.25rem;
  font-size: 1rem;
}

.feature-description {
  color: #4b5563;
  font-size: 0.875rem; /* 移动设备稍小字体 */
  line-height: 1.5;
}

.recruitment-link {
  display: inline-flex;
  align-items: center;
  color: #2563eb;
  font-weight: 600;
  transition: color 0.2s ease;
  text-decoration: none;
  margin-top: 1rem;
  font-size: 1rem;
  padding: 0.5rem 0; /* 增加点击区域 */
}

.recruitment-link:hover {
  color: #1e40af;
}

.arrow-icon::before {
  content: "\f061";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  margin-left: 0.5rem;
}

/* 针对小屏幕手机的额外优化 */
@media (max-width: 375px) {
  .section-title {
    font-size: 1.25rem;
  }
  
  .content-title {
    font-size: 1.25rem;
  }
  
  .achievement-card {
    max-width: 10rem;
    padding: 0.75rem;
  }
  
  .achievement-number {
    font-size: 1rem;
  }
}
</style>
